/**
 * Created by mrocha on 6/16.
 */

import fabric           from  'fabric.js/dist/fabric.require';

//======================================================================================
// Create a 'start' shape
// Targets Behaviors and Workflow canvases.
//======================================================================================
export const ExitClass = fabric.util.createClass(fabric.Rect, {

    type: '"exitcommand"',

    initialize: function(opt) {
        const options = opt || {};

        this.callSuper('initialize', options);
        this.set('label', options.label || '');
        this.set('icon',  options.icon  || '');

        this.icon = this.icon || '';

        this.left = this.left - this.width /2;
        this.top  = this.top  - this.height/2;

        this.hasControls = true;
        this.hasRotatingPoint = false;
        this.objectCaching = false;
        this.visible = options.visible;
        this.hoverCursor = 'pointer';
    },

    toObject: function() {
        return fabric.util.object.extend(this.callSuper('toObject'), {
            label: this.get('label')
        });
    },

    _render: function(ctx) {
        ctx.lineWidth = '0.5';

        ctx.beginPath();
        ctx.moveTo( -(this.width/2), +(this.height/2 ));
        ctx.lineTo( -(this.width/2), -(this.height/2 ));
        ctx.lineTo( +(this.width/2), -(this.height/2) );
        ctx.lineTo( +(this.width/2), +(this.height/2 ) );
        ctx.closePath();

        ctx.fillStyle   = '#FFFFFF';
        ctx.fill();
        ctx.stroke();

        let centerX = this.left+(this.width/2);
        let centerY = this.top+(this.height/2 );
        ctx.beginPath();
        ctx.font = '18pt Calibri';
        ctx.fillStyle = 'gray';
        ctx.textAlign = 'center';
        ctx.fillText('[ ]', centerX, centerY+5);

        centerX -= 5;
        ctx.beginPath();
        ctx.moveTo(centerX, centerY);
        ctx.lineTo(centerX+10, centerY);
        ctx.lineTo(centerX+5, centerY-3);
        ctx.lineTo(centerX+5, centerY+3);
        ctx.lineTo(centerX+10, centerY);
        ctx.fill();
        ctx.stroke();

        ctx.closePath();
    }
});

